module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-bronze-brushed-4045-scale.074abf74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-bronze-brushed-4045-scale.jpg
// module id = 1113
// module chunks = 37